module.exports = __webpack_public_path__ + "img/item15.5a6c8eaf.png";